<template>
  <v-flex xs12>
    <v-card>
      <v-card-text>
        <h4>Competitions:</h4>
        <p v-if="currentCompetitions">
          <template v-for="c in currentCompetitions">
            <span :key="c">{{c}}<br/></span>
          </template>
        </p>
        <p v-else>
          No competitions have been added to this organization yet.
        </p>

        <v-layout row justify-center>
          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-btn slot="activator" small outline>Add to Competitions</v-btn>

            <v-card>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-title>
                  <span class="headline">Add Competition</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-select
                          :items="avalableCompetitions"
                          :rules="required"
                          v-model="newCompetition"
                          label="Competition to add to"
                          required
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-flex xs12></v-flex>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
                  <v-btn color="blue darken-1" flat @click="submit">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
/*global firebase*/
export default {
  name: "NatOrgCompetitions",
  props: {
    id: String,
    obj: Object
  },
  data: () => ({
    dialog: false,
    valid: true,
    newCompetition: "",
    required: [v => !!v || "Required"]
  }),
  computed: {
    avalableCompetitions() {
      let comps = this.$store.getters.competitions;

      let nOcompetitions = this.$store.getters.competitionByNo(this.id)
      if (nOcompetitions) {
        let currCompVals = Object.values(nOcompetitions)
        var aComps = new Array();
        for (var key in comps) {
          if (!currCompVals.includes(key)) {
            aComps.push({ text: comps[key].name, value: key });
          }
        }
        return aComps;
      } else {
        let keys = Object.keys(comps);
        return keys.map(k => {
          return { text: comps[k].name, value: k };
        });
      }
    },
    currentCompetitions() {
      let nOcompetitions = this.$store.getters.competitionByNo(this.id)
      if (nOcompetitions) {
        let currCompVals = Object.values(nOcompetitions)
        return currCompVals.map(k => {
          return this.$store.getters.competitions[k].name;
        });
      }
      return false;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        firebase.database().ref("nocompetitions/" + this.id).push(this.newCompetition);
        this.newCompetition = null;
        this.dialog = false;
      }
    }
  }
};
</script>
